import React, { useRef, useState } from "react"
import styled from "styled-components"
import colors from "../../styles/colors"
import fonts from "../../styles/fonts"
import breakpoints from "../../styles/breakpoints"
import { Col, Row } from "styled-bootstrap-grid"
import { graphql, Link, useStaticQuery } from "gatsby"
import Slider from "react-slick"
import LeftArrow from "../../resources/img/ui/arrows/arrow-left-green-sm.svg"
import RightArrow from "../../resources/img/ui/arrows/arrow-right-green-sm.svg"
import { connect } from "react-redux"
import { getProductLink } from "../../services/links"
import { addAction } from "../../store/actions/cart/index"
import { isAdded, isLoading } from "../../store/reducers"
import {
  getLocalisedPrice,
  getProductCardContent,
} from "../../services/productHelper"
import { GatsbyImage } from "gatsby-plugin-image"

const UpsellCarousel = styled.div`
  margin-top: 14px;
  position: relative;
`

const StyledSlider = styled(Slider)`
  width: 100%;
  div {
    outline: none;
  }
`

const Slide = styled.div`
  padding: 0 22px;
`

const UpsellDetails = styled.div`
  padding: 12px 0 12px 23px;
  display: flex;
  justify-content: center;
  align-items: center;

  /* @media (min-width: ${breakpoints.md}) {
    padding: 12px 0 12px 32px;
  } */
`

const StyledImage = styled(GatsbyImage)`
  width: 126px;
  height: 126px;

  @media (min-width: ${breakpoints.md}) {
    width: 148px;
    height: 148px;
  }
`

const UpsellTitle = styled.h3`
  ${fonts.helveticaNeueMedium};
  color: ${colors.black};
  font-size: 12px;
  line-height: 19px;
`

const UpsellDetail = styled.div`
  ${fonts.helveticaNeueLight};
  color: ${colors.textGrey};
  font-size: 10px;
  line-height: 14px;
  margin: 0 0 6px;
  a {
    color: ${colors.textGrey};
  }
`


const StyledButton = styled.button`
  outline: none;
  padding: 0;
  background: transparent;
  border: none;
  display: flex;
  cursor: pointer;
`

const UpsellButtonsContainer = styled.div`
  min-width: 100%;
  margin-bottom: 100px;
  button {
    margin-bottom: 5px;
  }
`
const StyledLink = styled(Link)`
  height: 100%;
  display: flex;
`

const ButtonText = styled.span`
  ${fonts.helveticaNeueLight};
  color: ${colors.green};
  font-size: 10px;
  line-height: normal;
  text-decoration: underline;
`


const ArrowContainer = styled.div`
  display: flex;
    margin-bottom: 100px;
  justify-content: space-between;
  width: 100%;
  position: absolute;
  top: 50%;
  padding: 0 2px;
  pointer-events: none;
  transform: translateY(-50%);
  img {
    cursor: pointer;
    pointer-events: auto;
  }
`

const UpsellRow = styled(Row)`
  display: flex;
  flex-wrap: nowrap;
`

const UpsellContainer = styled.div`
  padding: 18px 26px;
`

const Title = styled.div`
  ${fonts.selfModern};
  font-size: 14px;
  line-height: 19px;
  color: ${colors.trueBlack};
  padding-left: 8px;
`

const Price = styled.div`
  ${fonts.helveticaNeueLight};
  font-size: 10px;
  line-height: 12px;
  position: relative;
  color: ${(props) =>
    props.sale
      ? colors.green
      : props.$crossed
      ? colors.mediumDarkGrey
      : colors.black};
  margin-left: ${(props) => props.$crossed && "13px"};
  font-style: ${(props) => (props.$crossed ? "italic" : "none")};
  span {
    ${fonts.helveticaNeueMedium};
  }
  @media (min-width: ${breakpoints.md}) {
    font-size: 12px;
  }
`

const Line = styled.div`
  width: 100%;
  position: absolute;
  width: 130%;
  height: 1px;
  background: ${colors.mediumDarkGrey};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const PriceSection = styled.div`
  display: flex;
  padding: 4px 0 6px;
`

const Upsell = (props) => {
  const data = useStaticQuery(graphql`
    query MiniCartQuery {
      home: contentfulHome {
        campaign
      }
      products: allShopifyProduct(filter: { tags: { in: "Featured" } }) {
        nodes {
          ...UpsellProductFragment
        }
      }
      campaign: allShopifyProduct(filter: { tags: { in: "Campaign" } }) {
        nodes {
          ...UpsellProductFragment
        }
      }
      productContents: allContentfulProductContent {
        nodes {
          ...ProductCardContentFragment
        }
      }
    }
  `)
  const { products, productContents, home, campaign } = data
  const { t } = props
  const upsells = products.nodes
  const campaginProducts = campaign.nodes
  const [slideIndex, setSlideIndex] = useState(0)
  let slider = useRef()

  const next = () => {
    slider.current.slickNext()
  }
  const previous = () => {
    slider.current.slickPrev()
  }

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    fade: false,
    swipe: true,
    swipeToSlide: true,
    draggable: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: slideIndex,
    adaptiveHeight: false,
    beforeChange: (current, next) => setSlideIndex(next),
  }

  const langTag = process.env.LANG_TAG
  const isFrance = langTag === "fr-FR"

  const localisedProductContents = productContents.nodes.filter((content) => {
    if (isFrance) {
      return content.node_locale === "fr"
    } else {
      return content.node_locale !== "fr"
    }
  })

  const sellingProducts = (home.campaign ? campaginProducts : upsells).map(
    (product) => getProductCardContent(product, localisedProductContents)
  )

  return sellingProducts.length > 0 ? (
    <UpsellContainer>
      <Title>
        {home.campaign
          ? t("minicart.upsell.support_ukraine_title")
          : t("minicart.upsell_title")}
      </Title>
      <UpsellCarousel>
        <StyledSlider {...settings} ref={slider}>
          {sellingProducts.map((item, index) => {
            const descriptionFr =
              item.metafields.length > 0 &&
              item.metafields.find(
                (field) => field.key.trim() === "description_fr"
              )
            const description = isFrance
              ? descriptionFr && descriptionFr.value
              : item.description

            const isHoodie = item.handle === "kimai-x-save-the-children-hoodie"
            const regex = /((?!=|\!|\.).)+(.)/
            let firstParagraph

            if ((firstParagraph = regex.exec(description)) !== null) {
              firstParagraph = firstParagraph[0]
            }

            let mainImage =
              item.media.length > 1 ? item?.media[1] : item?.media[0]

            let price
            let salePrice
            let saleProduct = false
            let discountAmount = 0

            item.tags.forEach((tag) => {
              if (tag.includes("discount-")) {
                saleProduct = true
                discountAmount = tag.match(/\d+/g)[0]
              }
            })

            price = getLocalisedPrice(
              item.priceRangeV2.minVariantPrice.amount,
              item.priceRangeV2.minVariantPrice.currencyCode
            )
            if (saleProduct) {
              salePrice =
                item.priceRangeV2.minVariantPrice.amount *
                ((100 - discountAmount) / 100)
              salePrice = getLocalisedPrice(
                salePrice,
                item.priceRangeV2.minVariantPrice.currencyCode
              )
            }

            return (
              <Slide key={index}>
                <UpsellRow>
                  <Col xs={"auto"} sm={"auto"} md={"auto"}>
                    <Link to={getProductLink(item.handle)}>
                      <StyledImage
                        image={mainImage.image.gatsbyImageData}
                        alt={item.title}
                        objectFit={"contain"}
                      />
                    </Link>
                  </Col>
                  <UpsellDetails>
                    <div>
                      <UpsellTitle>{item.title}</UpsellTitle>
                      <PriceSection>
                        {salePrice && (
                          <Price sale>
                            <span>{salePrice}</span>
                          </Price>
                        )}
                        <Price $crossed={salePrice? 1 : 0}>
                          <span>{price}</span>
                          {salePrice && <Line />}
                        </Price>
                      </PriceSection>
                      {isHoodie ? (
                        <UpsellDetail>
                          {t("minicart.hoodie.description")}
                        </UpsellDetail>
                      ) : (
                        <UpsellDetail
                          dangerouslySetInnerHTML={{
                            __html:
                              firstParagraph.length > 90
                                ? firstParagraph.substring(0, 90) + "..."
                                : firstParagraph,
                          }}
                        />
                      )}
<UpsellButtonsContainer>
  <StyledLink to={getProductLink(item.handle)}>
    <ButtonText>{t("minicart.add_to_cart")}</ButtonText>
  </StyledLink>
</UpsellButtonsContainer>
                    </div>
                  </UpsellDetails>
                </UpsellRow>
              </Slide>
            )
          })}
        </StyledSlider>
        <ArrowContainer>
          {sellingProducts.length > 1 && (
            <>
              <StyledButton onClick={() => previous()}>
                <img src={LeftArrow} alt={"previous"} />
              </StyledButton>
              <StyledButton onClick={() => next()}>
                <img src={RightArrow} alt="next" />
              </StyledButton>
            </>
          )}
        </ArrowContainer>
      </UpsellCarousel>
    </UpsellContainer>
  ) : null
}

const mapStateToProps = (state) => {
  return {
    isLoading: isLoading(state),
    isAdded: isAdded(state),
  }
}

const mapDispatchToProps = {
  addAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(Upsell)
